import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: TenantState = {
  TenantID: null,
  DefaultLocale: null,
  tenantAdditionalInfo: {
    TenantName: '',
    Identifier: null
  },
  BlockSignUpRewardFromInvited: false,
  CssTheme: '',
  CustomDeductionCheckSchedule: '',
  DisableHelp: false,
  DisableTutorial: false,
  SignUpWelcomeDescription: '',
  SignUpWelcomeImageID: null,
  SignUpWelcomeTitle: '',
  SignUpWelcomeButtonLabel: '',
  SignUpWelcomeButtonLink: '',
  IsInviteCodeDisplay: false,
  IsInviteCodeMandatory: false,
  ShowBehavioursOnAdminCommon: false,
  ShowCampaignsInsideCategories: false,
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {},
  translations: {},
  tenantsList: [],
  referralCampaignConfigurations: {
    IsReferralAvailable: false,
    referralInstructions: []
  },
  isInactivityEnabled: false,
  ShouldLimitRewardsUsers: false,
  RewardsUsersLimit: null,
  WaitlistScreenImageID: null,
  WaitlistScreenTitle: '',
  WaitlistScreenDescription: '',
  WaitlistScreenSubtitle: '',
  WaitlistScreenButtonLabel: '',
  WaitlistScreenMessageTitle: '',
  WaitlistScreenMessageDescription: '',
  TransitValidationCardTitle: null,
  TransitValidationCardSubTitle: null,
  TransitValidationCardImageID: null,
  TransitValidationImageUrl: null,
  TVDRedemptionApiConfigID: null,
  transitValidationProducts: [],
  IsBytemarkClientForTVD: false,
  hasSpecificProducts: false,
  allProductList: [],
  SupportStoreValueRedemptions: false,
  DisplayActionBoxCategory: false,
  EarnEmptyScreenTitle: '',
  EarnEmptyScreenDescription: '',
  RedeemEmptyScreenTitle: '',
  RedeemEmptyScreenDescription: '',
  AllowMsbAccountIDUpload: false,
  HideAllOffers: false,
  HideAllOffersAtUTC: null,
  HideAllCampaigns: false,
  HideAllCampaignsAtUTC: null,
  BlockedPasswordsLimit: 1,
  IsUserDailyRedemptionLimitEnabled: false,
  IsProviderConnectionRequired: false,
  tenantProviders: [],
  tenantTVDUserList: [],
  IsEmailNotificationsEnabled: false,
  IsNotificationsSectionEnabled: false,
  IsSMSNotificationsEnabled: false
}

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantID: (state, action: PayloadAction<string>) => {
      state.TenantID = action.payload
    },
    setTenantName: (state, action: PayloadAction<string>) => {
      state.tenantAdditionalInfo.TenantName = action.payload
    },
    setTenantInfo: (state, action: PayloadAction<TenantState>) => {
      if (!action.payload.tenantAdditionalInfo) {
        state.tenantAdditionalInfo.TenantName = 'No Name'
      }
      return {
        ...state,
        ...action.payload,
        referralCampaignConfigurations: action.payload
          .referralCampaignConfigurations || {
          IsReferralAvailable: false
        }
      }
    },
    setTenantSelectedTranslations: (
      state,
      action: PayloadAction<SetTenantTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: action.payload.translations
      }
    },
    setTenantsList: (state, action: PayloadAction<TenantInfo[]>) => {
      state.tenantsList = action.payload
    },
    setMsbAccountIDUploadFlag: (state, action: PayloadAction<boolean>) => {
      state.AllowMsbAccountIDUpload = action.payload
    }
  }
})

export const {
  setTenantID,
  setTenantInfo,
  setTenantSelectedTranslations,
  setTenantName,
  setTenantsList,
  setMsbAccountIDUploadFlag
} = tenantSlice.actions
export const tenantReducer = tenantSlice.reducer
